/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Guedder API
 * Contrato oficial da API v3 do Guedder (API-First).
 *
 * ## Modelo de resposta
 *
 * A v3 NÃO usa envelope. O status HTTP 2xx já comunica sucesso e o cliente
 * gerado é uma sealed-union por status-code. Sem `success`/`code`/`message` de
 * cerimônia. Respostas de objeto único retornam o tipo de domínio diretamente:
 * ```json
 * // 200 GET /api/v3/eventos/{eventoId}  → DadosBasicosEventoDto
 * { "id": "...", "nome": "..." }
 * ```
 *
 * ## Paginação
 *
 * TODA resposta de coleção usa um único shape canônico `Paged<T>`:
 * ```json
 * // 200 GET /api/v3/eventos  → Paged<DadosBasicosEventoDto>
 * { "content": [ { "id": "...", "nome": "..." } ], "page": { PageInfo } }
 * ```
 * `PageInfo` é offset-based, compatível com Spring Data `Page<T>`. Coleções
 * bounded (categorias, carrossel de destaque, devices, line-up) retornam uma
 * página única; params reais (`page`/`size`/`sort`) podem ser adicionados depois
 * sem quebrar o contrato (adição não-breaking).
 *
 * ## Erros
 *
 * Erro tem um único modelo: RFC 7807 (`ProblemDetail`), gerado nativamente pelo
 * Spring 6+. Validação de campo vem em `errors[]` dentro do próprio ProblemDetail.
 * ```json
 * { "type": "...", "title": "Not Found", "status": 404, "detail": "..." }
 * ```
 *
 * ## Convenções v3.1
 *
 * A v3.1 consolida as convenções de nomeação de recursos:
 * - **Sem sufixo `/publico`**: endpoints públicos não carregam mais o sufixo
 *   `/publico` no path; a ausência de `security` já comunica que são abertos.
 * - **Recursos plurais em kebab-case**: coleções usam nomes plurais
 *   (`/eventos`, `/ingressos`, `/compras`, `/cotacoes`) e paths compostos usam
 *   kebab-case (`/notification-tokens`, `/categorias-evento`,
 *   `/transferencias-pendentes`, `/wallet-config`).
 * - **Sub-recursos aninhados sob `/eventos`**: atrações, lotes, parâmetros de
 *   venda, visualizações e ingressos de check-in são modelados como
 *   sub-recursos de `/eventos/{eventoId}/...`.
 * - **Dois enums distintos para ingresso**: `StatusPagamentoIngresso` (estado
 *   de pagamento) e `CicloDeVidaIngresso` (eixo temporal: ativo/encerrado)
 *   deixam de ser misturados em um único enum. A custódia do ingresso
 *   (transferência em curso) é um terceiro eixo, servido pelo recurso
 *   `/transferencias-pendentes` — ver ADR-0016.
 *
 * ## Caixa dos enums
 *
 * Todo enum desta API é aceito em **qualquer caixa** na entrada — em query
 * params, path params e corpo JSON. `?cicloDeVida=ativo`, `Ativo` e `ATIVO`
 * são equivalentes.
 *
 * Isto é uma garantia do contrato, não um detalhe de implementação: existe
 * para que URLs compartilháveis e chamadas escritas à mão (curl, Postman)
 * não precisem carregar o valor em maiúsculo, que é desconfortável de ler e
 * digitar.
 *
 * A **saída** continua sempre no valor canônico em MAIÚSCULO. Clientes devem
 * comparar respostas contra o valor canônico, nunca assumir a caixa que
 * enviaram.
 *
 * ## Datas e fuso horário
 *
 * Datas têm **dois tipos distintos** neste contrato (ADR-0009), hoje
 * confundidos sob o mesmo `format: date-time`:
 *
 * - **Instante de auditoria** — `dataCriacao`, `dataCompra`, `dataCheckin`,
 *   `checkIn`, `realizadoEm`, `ProblemDetail.timestamp`. É um instante UTC
 *   (`...Z`); a zona não é semanticamente relevante e o valor deve ser
 *   renderizado no fuso do dispositivo.
 * - **Hora-de-parede do evento** — `dataInicio`, `dataFim`, `inicioVendas`,
 *   `terminoVendas`, `dataInicioSessao`/`dataFimSessao`,
 *   `inicioCheckin`/`terminoCheckin`, `dataEvento`, `dataFimEvento`. Também
 *   viaja como instante UTC no fio, mas representa uma hora local num lugar:
 *   deve ser renderizada **no fuso do evento**.
 *
 * Cada campo diz a qual dos dois pertence, na própria `description`.
 *
 * Todo recurso que carrega hora-de-parede expõe um campo `timezone` (IANA,
 * ex.: `America/Sao_Paulo`) — inclusive os que apenas desnormalizam a data de
 * um evento (ingresso, transferência, repasse), justamente para o cliente
 * nunca precisar buscar o evento só para saber em que fuso renderizar.
 *
 * **Renderizar hora-de-parede no fuso do dispositivo, ou com offset chumbado
 * (`-0300`), é incorreto**: quebra em horário de verão e em qualquer evento
 * fora do Brasil. Cada cliente usa sua ferramenta nativa
 * (`Temporal.ZonedDateTime` no web, `package:timezone` no Flutter) — o padrão
 * compartilhado é o contrato, não a biblioteca.
 *
 * Nas **requisições**, todo valor `format: date-time` (corpo ou query param)
 * deve carregar offset explícito ISO-8601 — `Z` ou `±hh:mm`. Não existe fuso
 * implícito de servidor: omitir o offset é erro do cliente. Já `format: date`
 * (ex.: `dataNascimento`) é data de calendário, sem hora e sem fuso — a regra
 * não se aplica.
 *
 * Duas exceções de compatibilidade Sympla em `GET /api/v3/eventos`, ambas
 * fora da convenção acima: os params `from`/`to` usam o formato Sympla
 * `YYYY-MM-DD[ HH:mm:ss]` interpretado em UTC e **não** aceitam offset; e o
 * param `timezone` daquela rota é filtro de compatibilidade — **não** é o
 * fuso do evento.
 *
 * ## Retrocompatibilidade
 *
 * Os paths `/api/v1/...` e `/api/v2/...` permanecem funcionais com seu próprio
 * envelope `RestObject`. A v3 diverge deliberadamente dessa simetria (ver ADR
 * de modelagem de resposta v3): é superfície nova, contract-first, gerada.
 * Os clients gerados apontam para `/api/v3/...`.
 *
 * OpenAPI spec version: 3.8.0
 */
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import {
  inject
} from '@angular/core';

import {
  injectMutation,
  injectQuery
} from '@tanstack/angular-query-experimental';
import type {
  CreateMutationOptions,
  CreateMutationResult,
  CreateQueryOptions,
  CreateQueryResult,
  MutationFunction,
  QueryFunction
} from '@tanstack/angular-query-experimental';

import {
  fromEvent,
  lastValueFrom
} from 'rxjs';

import {
  takeUntil
} from 'rxjs/operators';

import type {
  BadRequestResponse,
  CheckinConflictProblem,
  CheckinPayload,
  CheckinResultadoDto,
  CheckinRetroativoPayload,
  CheckinSaldoDto,
  CheckpointDashboardDto,
  CheckpointDto,
  CheckpointPayload,
  ForbiddenResponse,
  ListarCheckInsParams,
  ListarCheckpointsParams,
  NotFoundResponse,
  ObterContextoSelfCheckinParams,
  PagedCheckin,
  PagedCheckpoint,
  SelfCheckinContextoDto,
  SelfCheckinPayload,
  UnauthorizedResponse
} from '../schemas';




type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}
export const obterContextoSelfCheckin = (
    http: HttpClient,
    eventoId: string,
    loteId: string,
    params?: ObterContextoSelfCheckinParams, options?: { signal?: AbortSignal | null }
  ): Promise<SelfCheckinContextoDto> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/eventos/${eventoId}/lotes/${loteId}/self-checkin`;
    const request$ = http.get<SelfCheckinContextoDto>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getObterContextoSelfCheckinQueryKey = (eventoId: string,
    loteId: string,
    params?: ObterContextoSelfCheckinParams,) => {
    return [
    `/api/v3/eventos/${eventoId}/lotes/${loteId}/self-checkin`, ...(params ? [params] : [])
    ] as const;
    }


export const getObterContextoSelfCheckinQueryOptions = <TData = Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError = NotFoundResponse>(http: HttpClient, eventoId: string,
    loteId: string,
    params?: ObterContextoSelfCheckinParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getObterContextoSelfCheckinQueryKey(eventoId,loteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof obterContextoSelfCheckin>>> = ({ signal }) => obterContextoSelfCheckin(http, eventoId,loteId,params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined && loteId !== null && loteId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError, TData>
}

export type ObterContextoSelfCheckinQueryResult = NonNullable<Awaited<ReturnType<typeof obterContextoSelfCheckin>>>
export type ObterContextoSelfCheckinQueryError = NotFoundResponse


/**
 * @summary Contexto da página pública de self check-in
 */

export function injectObterContextoSelfCheckin<TData = Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError = NotFoundResponse>(
 eventoId: string | (() => string),
    loteId: string | (() => string),
    params?: ObterContextoSelfCheckinParams | (() => ObterContextoSelfCheckinParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterContextoSelfCheckin>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _loteId = typeof loteId === 'function' ? loteId() : loteId;
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getObterContextoSelfCheckinQueryOptions(http, _eventoId, _loteId, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const realizarSelfCheckin = (
    http: HttpClient,
    eventoId: string,
    loteId: string,
    selfCheckinPayload: SelfCheckinPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckinResultadoDto> => {

    const url = `/api/v3/eventos/${eventoId}/lotes/${loteId}/self-checkin`;
    const request$ = http.post<CheckinResultadoDto>(url, selfCheckinPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getRealizarSelfCheckinMutationOptions = <TError = BadRequestResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof realizarSelfCheckin>>, TError,{eventoId: string;loteId: string;data: SelfCheckinPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof realizarSelfCheckin>>, TError,{eventoId: string;loteId: string;data: SelfCheckinPayload}, TContext> => {

const mutationKey = ['realizarSelfCheckin'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof realizarSelfCheckin>>, {eventoId: string;loteId: string;data: SelfCheckinPayload}> = (props) => {
          const {eventoId,loteId,data} = props ?? {};

          return  realizarSelfCheckin(http, eventoId,loteId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RealizarSelfCheckinMutationResult = NonNullable<Awaited<ReturnType<typeof realizarSelfCheckin>>>
    export type RealizarSelfCheckinMutationBody = SelfCheckinPayload
    export type RealizarSelfCheckinMutationError = BadRequestResponse | NotFoundResponse | CheckinConflictProblem

    /**
 * @summary Realiza o self check-in por e-mail ou código de convite
 */
export const injectRealizarSelfCheckin = <TError = BadRequestResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof realizarSelfCheckin>>, TError,{eventoId: string;loteId: string;data: SelfCheckinPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof realizarSelfCheckin>>,
        TError,
        {eventoId: string;loteId: string;data: SelfCheckinPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const realizarSelfCheckinMutationOptions = getRealizarSelfCheckinMutationOptions(http, options);

      return injectMutation(() => realizarSelfCheckinMutationOptions);
    }
    export const listarCheckIns = (
    http: HttpClient,
    eventoId: string,
    params?: ListarCheckInsParams, options?: { signal?: AbortSignal | null }
  ): Promise<PagedCheckin> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/eventos/${eventoId}/check-ins`;
    const request$ = http.get<PagedCheckin>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getListarCheckInsQueryKey = (eventoId: string,
    params?: ListarCheckInsParams,) => {
    return [
    `/api/v3/eventos/${eventoId}/check-ins`, ...(params ? [params] : [])
    ] as const;
    }


export const getListarCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof listarCheckIns>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(http: HttpClient, eventoId: string,
    params?: ListarCheckInsParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckIns>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListarCheckInsQueryKey(eventoId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listarCheckIns>>> = ({ signal }) => listarCheckIns(http, eventoId,params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof listarCheckIns>>, TError, TData>
}

export type ListarCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof listarCheckIns>>>
export type ListarCheckInsQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


/**
 * @summary Histórico de check-ins do evento
 */

export function injectListarCheckIns<TData = Awaited<ReturnType<typeof listarCheckIns>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 eventoId: string | (() => string),
    params?: ListarCheckInsParams | (() => ListarCheckInsParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckIns>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckIns>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getListarCheckInsQueryOptions(http, _eventoId, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const registrarCheckIn = (
    http: HttpClient,
    eventoId: string,
    checkinPayload: CheckinPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckinResultadoDto> => {

    const url = `/api/v3/eventos/${eventoId}/check-ins`;
    const request$ = http.post<CheckinResultadoDto>(url, checkinPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getRegistrarCheckInMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckIn>>, TError,{eventoId: string;data: CheckinPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckIn>>, TError,{eventoId: string;data: CheckinPayload}, TContext> => {

const mutationKey = ['registrarCheckIn'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrarCheckIn>>, {eventoId: string;data: CheckinPayload}> = (props) => {
          const {eventoId,data} = props ?? {};

          return  registrarCheckIn(http, eventoId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrarCheckInMutationResult = NonNullable<Awaited<ReturnType<typeof registrarCheckIn>>>
    export type RegistrarCheckInMutationBody = CheckinPayload
    export type RegistrarCheckInMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem

    /**
 * @summary Registra check-in por QR, código ou reconhecimento facial
 */
export const injectRegistrarCheckIn = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckIn>>, TError,{eventoId: string;data: CheckinPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof registrarCheckIn>>,
        TError,
        {eventoId: string;data: CheckinPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const registrarCheckInMutationOptions = getRegistrarCheckInMutationOptions(http, options);

      return injectMutation(() => registrarCheckInMutationOptions);
    }
    export const registrarCheckInRetroativo = (
    http: HttpClient,
    eventoId: string,
    ingressoId: string,
    janelaId: string,
    checkinRetroativoPayload: CheckinRetroativoPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckinResultadoDto> => {

    const url = `/api/v3/eventos/${eventoId}/ingressos/${ingressoId}/janelas/${janelaId}/checkin`;
    const request$ = http.post<CheckinResultadoDto>(url, checkinRetroativoPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getRegistrarCheckInRetroativoMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckInRetroativo>>, TError,{eventoId: string;ingressoId: string;janelaId: string;data: CheckinRetroativoPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckInRetroativo>>, TError,{eventoId: string;ingressoId: string;janelaId: string;data: CheckinRetroativoPayload}, TContext> => {

const mutationKey = ['registrarCheckInRetroativo'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registrarCheckInRetroativo>>, {eventoId: string;ingressoId: string;janelaId: string;data: CheckinRetroativoPayload}> = (props) => {
          const {eventoId,ingressoId,janelaId,data} = props ?? {};

          return  registrarCheckInRetroativo(http, eventoId,ingressoId,janelaId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegistrarCheckInRetroativoMutationResult = NonNullable<Awaited<ReturnType<typeof registrarCheckInRetroativo>>>
    export type RegistrarCheckInRetroativoMutationBody = CheckinRetroativoPayload
    export type RegistrarCheckInRetroativoMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem

    /**
 * @summary Registra check-in retroativo numa janela específica
 */
export const injectRegistrarCheckInRetroativo = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | CheckinConflictProblem,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof registrarCheckInRetroativo>>, TError,{eventoId: string;ingressoId: string;janelaId: string;data: CheckinRetroativoPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof registrarCheckInRetroativo>>,
        TError,
        {eventoId: string;ingressoId: string;janelaId: string;data: CheckinRetroativoPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const registrarCheckInRetroativoMutationOptions = getRegistrarCheckInRetroativoMutationOptions(http, options);

      return injectMutation(() => registrarCheckInRetroativoMutationOptions);
    }
    export const obterSaldoCheckIn = (
    http: HttpClient,
    eventoId: string, options?: { signal?: AbortSignal | null }
  ): Promise<CheckinSaldoDto> => {

    const url = `/api/v3/eventos/${eventoId}/check-ins/saldo`;
    const request$ = http.get<CheckinSaldoDto>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getObterSaldoCheckInQueryKey = (eventoId: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/check-ins/saldo`
    ] as const;
    }


export const getObterSaldoCheckInQueryOptions = <TData = Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(http: HttpClient, eventoId: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getObterSaldoCheckInQueryKey(eventoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof obterSaldoCheckIn>>> = ({ signal }) => obterSaldoCheckIn(http, eventoId, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError, TData>
}

export type ObterSaldoCheckInQueryResult = NonNullable<Awaited<ReturnType<typeof obterSaldoCheckIn>>>
export type ObterSaldoCheckInQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


/**
 * @summary Saldo de check-in do evento (presentes / total / por lote)
 */

export function injectObterSaldoCheckIn<TData = Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 eventoId: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterSaldoCheckIn>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getObterSaldoCheckInQueryOptions(http, _eventoId, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const listarCheckpoints = (
    http: HttpClient,
    eventoId: string,
    params?: ListarCheckpointsParams, options?: { signal?: AbortSignal | null }
  ): Promise<PagedCheckpoint> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/eventos/${eventoId}/checkpoints`;
    const request$ = http.get<PagedCheckpoint>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getListarCheckpointsQueryKey = (eventoId: string,
    params?: ListarCheckpointsParams,) => {
    return [
    `/api/v3/eventos/${eventoId}/checkpoints`, ...(params ? [params] : [])
    ] as const;
    }


export const getListarCheckpointsQueryOptions = <TData = Awaited<ReturnType<typeof listarCheckpoints>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(http: HttpClient, eventoId: string,
    params?: ListarCheckpointsParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckpoints>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListarCheckpointsQueryKey(eventoId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listarCheckpoints>>> = ({ signal }) => listarCheckpoints(http, eventoId,params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof listarCheckpoints>>, TError, TData>
}

export type ListarCheckpointsQueryResult = NonNullable<Awaited<ReturnType<typeof listarCheckpoints>>>
export type ListarCheckpointsQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


/**
 * @summary Lista os pontos de check-in do evento
 */

export function injectListarCheckpoints<TData = Awaited<ReturnType<typeof listarCheckpoints>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 eventoId: string | (() => string),
    params?: ListarCheckpointsParams | (() => ListarCheckpointsParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckpoints>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof listarCheckpoints>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getListarCheckpointsQueryOptions(http, _eventoId, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const criarCheckpoint = (
    http: HttpClient,
    eventoId: string,
    checkpointPayload: CheckpointPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckpointDto> => {

    const url = `/api/v3/eventos/${eventoId}/checkpoints`;
    const request$ = http.post<CheckpointDto>(url, checkpointPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getCriarCheckpointMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCheckpoint>>, TError,{eventoId: string;data: CheckpointPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof criarCheckpoint>>, TError,{eventoId: string;data: CheckpointPayload}, TContext> => {

const mutationKey = ['criarCheckpoint'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof criarCheckpoint>>, {eventoId: string;data: CheckpointPayload}> = (props) => {
          const {eventoId,data} = props ?? {};

          return  criarCheckpoint(http, eventoId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CriarCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof criarCheckpoint>>>
    export type CriarCheckpointMutationBody = CheckpointPayload
    export type CriarCheckpointMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Cria um ponto de check-in
 */
export const injectCriarCheckpoint = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCheckpoint>>, TError,{eventoId: string;data: CheckpointPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof criarCheckpoint>>,
        TError,
        {eventoId: string;data: CheckpointPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const criarCheckpointMutationOptions = getCriarCheckpointMutationOptions(http, options);

      return injectMutation(() => criarCheckpointMutationOptions);
    }
    export const atualizarCheckpoint = (
    http: HttpClient,
    eventoId: string,
    checkpointId: string,
    checkpointPayload: CheckpointPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckpointDto> => {

    const url = `/api/v3/eventos/${eventoId}/checkpoints/${checkpointId}`;
    const request$ = http.put<CheckpointDto>(url, checkpointPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getAtualizarCheckpointMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof atualizarCheckpoint>>, TError,{eventoId: string;checkpointId: string;data: CheckpointPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof atualizarCheckpoint>>, TError,{eventoId: string;checkpointId: string;data: CheckpointPayload}, TContext> => {

const mutationKey = ['atualizarCheckpoint'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof atualizarCheckpoint>>, {eventoId: string;checkpointId: string;data: CheckpointPayload}> = (props) => {
          const {eventoId,checkpointId,data} = props ?? {};

          return  atualizarCheckpoint(http, eventoId,checkpointId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AtualizarCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof atualizarCheckpoint>>>
    export type AtualizarCheckpointMutationBody = CheckpointPayload
    export type AtualizarCheckpointMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Atualiza um ponto de check-in
 */
export const injectAtualizarCheckpoint = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof atualizarCheckpoint>>, TError,{eventoId: string;checkpointId: string;data: CheckpointPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof atualizarCheckpoint>>,
        TError,
        {eventoId: string;checkpointId: string;data: CheckpointPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const atualizarCheckpointMutationOptions = getAtualizarCheckpointMutationOptions(http, options);

      return injectMutation(() => atualizarCheckpointMutationOptions);
    }
    export const removerCheckpoint = (
    http: HttpClient,
    eventoId: string,
    checkpointId: string, options?: { signal?: AbortSignal | null }
  ): Promise<void> => {

    const url = `/api/v3/eventos/${eventoId}/checkpoints/${checkpointId}`;
    const request$ = http.delete<void>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getRemoverCheckpointMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof removerCheckpoint>>, TError,{eventoId: string;checkpointId: string}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof removerCheckpoint>>, TError,{eventoId: string;checkpointId: string}, TContext> => {

const mutationKey = ['removerCheckpoint'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removerCheckpoint>>, {eventoId: string;checkpointId: string}> = (props) => {
          const {eventoId,checkpointId} = props ?? {};

          return  removerCheckpoint(http, eventoId,checkpointId,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoverCheckpointMutationResult = NonNullable<Awaited<ReturnType<typeof removerCheckpoint>>>

    export type RemoverCheckpointMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Remove um ponto de check-in
 */
export const injectRemoverCheckpoint = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof removerCheckpoint>>, TError,{eventoId: string;checkpointId: string}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof removerCheckpoint>>,
        TError,
        {eventoId: string;checkpointId: string},
        TContext
      > => {
      const http = inject(HttpClient);
      const removerCheckpointMutationOptions = getRemoverCheckpointMutationOptions(http, options);

      return injectMutation(() => removerCheckpointMutationOptions);
    }
    export const obterDashboardDoCheckpoint = (
    http: HttpClient,
    eventoId: string,
    checkpointId: string, options?: { signal?: AbortSignal | null }
  ): Promise<CheckpointDashboardDto> => {

    const url = `/api/v3/eventos/${eventoId}/checkpoints/${checkpointId}/dashboard`;
    const request$ = http.get<CheckpointDashboardDto>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getObterDashboardDoCheckpointQueryKey = (eventoId: string,
    checkpointId: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/checkpoints/${checkpointId}/dashboard`
    ] as const;
    }


export const getObterDashboardDoCheckpointQueryOptions = <TData = Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(http: HttpClient, eventoId: string,
    checkpointId: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getObterDashboardDoCheckpointQueryKey(eventoId,checkpointId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>> = ({ signal }) => obterDashboardDoCheckpoint(http, eventoId,checkpointId, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined && checkpointId !== null && checkpointId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError, TData>
}

export type ObterDashboardDoCheckpointQueryResult = NonNullable<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>>
export type ObterDashboardDoCheckpointQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


/**
 * @summary Painel em tempo real de um ponto de check-in
 */

export function injectObterDashboardDoCheckpoint<TData = Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 eventoId: string | (() => string),
    checkpointId: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof obterDashboardDoCheckpoint>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _checkpointId = typeof checkpointId === 'function' ? checkpointId() : checkpointId;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getObterDashboardDoCheckpointQueryOptions(http, _eventoId, _checkpointId, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






